wgsdk = window.wgsdk || {};
window.wgsdk = wgsdk;

function is_auth_user() {
    /* used in CMS content for tracking */
    var IS_AUTH_COOKIE_NAME = 'hlauth';
    return Cookies.get(IS_AUTH_COOKIE_NAME);
}

function get_lang() {
    return (Cookies.get(wgsdk.vars.LANG_COOKIE_NAME)  ||
            wgsdk.vars.CURRENT_REQUEST_LANGUAGE ||
            wgsdk.vars.DEFAULT_LANGUAGE)
}


wgsdk.account_info = (function ($, base64) {
    return function (cookie_name) {
        cookie_name = cookie_name || wgsdk.vars.ACCOUNT_INFO_COOKIE_NAME;
        var data_from_cookie = null,
            data = Cookies.get(cookie_name),
            instance = {},
            force_refresh_ajax_info_cookie_name = wgsdk.vars.FORCE_REFRESH_AJAX_INFO_COOKIE_NAME;

        if (data) {
            data = data.split(':')[0];
            data = base64.decode(data);
            data_from_cookie = $.parseJSON(data);
        }

        instance.has_data = function () {
            return !!data_from_cookie
        };

        instance.get_by_key = function (key, default_value) {
            default_value = typeof default_value !== 'undefined' ? default_value : '';
            if (!data_from_cookie || !data_from_cookie[key]) {
                return default_value;
            }
            return data_from_cookie[key];
        };
        instance.get_spa_id = function () {
            return instance.get_by_key('spa_id') || 0;
        };
        instance.get_nickname = function () {
            return instance.get_by_key('nickname');
        };
        instance.is_staff = function () {
            return instance.get_by_key('is_staff', 0);
        };
        instance.get_game_ban = function () {
            return instance.get_by_key('game_ban');
        };
        instance.get_clan_ban = function () {
            return instance.get_by_key('clan_ban');
        };
        instance.get_unread_notification_count = function () {
            return instance.get_by_key('unread_notifications_count', 0);
        };
        instance.get_all_notification_count = function () {
            return instance.get_by_key('all_notifications_count', 0);
        };
        instance.set_extra_cookie_lifetime = function () {
            var date = new Date(),
                cookie_value = Cookies.get(cookie_name),
                timeout;

            timeout = (wgsdk.vars.ACCOUNT_INFO_COOKIE_EXTRA_TIMEOUT_RATE
                * wgsdk.vars.ACCOUNT_INFO_COOKIE_TIMEOUT_SECONDS * 1000);

            date.setTime(date.getTime() + timeout);

            Cookies.remove(cookie_name);

            if (cookie_value !== undefined) {
                Cookies.set(cookie_name, cookie_value, {
                    expires: date,
                    path: '/',
                    domain: wgsdk.vars.ACCOUNT_INFO_COOKIE_DOMAIN,
                    samesite: wgsdk.vars.DEFAULT_COOKIE_SAMESITE,
                    secure: true
                });
            }
        };

        instance.set_force_refresh_ajax_info = function () {
            var date = new Date();
            timeout = (wgsdk.vars.ACCOUNT_INFO_COOKIE_EXTRA_TIMEOUT_RATE
                * wgsdk.vars.ACCOUNT_INFO_COOKIE_TIMEOUT_SECONDS * 1000);

            date.setTime(date.getTime() + timeout);
            Cookies.set(force_refresh_ajax_info_cookie_name, '1', {
                expires: date,
                path: '/',
                domain: wgsdk.vars.ACCOUNT_INFO_COOKIE_DOMAIN,
                samesite: wgsdk.vars.DEFAULT_COOKIE_SAMESITE,
                secure: true
            });
        };

        instance.get_force_refresh_ajax_info = function () {
            return Cookies.get(force_refresh_ajax_info_cookie_name);
        };

        instance.update_cookie_from_server = function (callback) {
            if (wgsdk.vars.AJAX_ACCOUNT_INFO_REQUEST) {
                var intervalId = setInterval(function () {
                    if (!wgsdk.vars.AJAX_ACCOUNT_INFO_REQUEST) {
                        var account_info = wgsdk.account_info();
                        clearInterval(intervalId);
                        callback && callback(wgsdk.account_info());
                    }
                }, 300);
                return;
            }

            if (instance.get_force_refresh_ajax_info()) {
                return;
            }

            var start = new Date();
            wgsdk.vars.AJAX_ACCOUNT_INFO_REQUEST = $.ajax({
                url: wgsdk.vars.ACCOUNT_AJAX_INFO_URL,
                cache: false,
                type: "GET",
                data: {'referrer': '' + document.location.pathname},
                success: function () {
                    var end = new Date();

                    if (end.getTime() - start.getTime() > wgsdk.vars.GETTING_ACCOUNT_INFO_COOKIE_CRITICAL_TIME_MS) {
                        instance.set_extra_cookie_lifetime();
                    }
                    var account_info = wgsdk.account_info();
                    wgsdk.vars.AJAX_ACCOUNT_INFO_REQUEST = null;
                    callback && callback(account_info);
                },
                error: function () {
                    instance.set_force_refresh_ajax_info();
                }
            });
        };

        instance.get_loginname = function () {
            return instance.get_by_key('loginname');
        };
        instance.is_premium_active = function () {
            return instance.get_by_key('is_premium_active', false);
        };
        instance.get_battles_count = function () {
            return instance.get_by_key('battles_count', 0);
        };
        instance.set_commonmenu_cookies = function() {
            var wgsdkVars = wgsdk.vars;

            var prefix = wgsdkVars.COMMON_MENU_COOKIE_PREFIX,
                path = wgsdkVars.COMMON_MENU_COOKIE_PATH;

            Cookies.set(prefix+'user_id', instance.get_spa_id(), {path: path, secure: true,
                samesite: wgsdk.vars.DEFAULT_COOKIE_SAMESITE});
            Cookies.set(prefix+'user_name', instance.get_nickname(), {path: path, secure: true,
                samesite: wgsdk.vars.DEFAULT_COOKIE_SAMESITE});
        };

        return instance;

    };
}(jQuery, wgsdk.base64));
